import { v4 } from 'uuid';
import { UserDAO } from '../../../../../../data/SystemManagementDAO';
import { Severity } from '../../../../../../types';
const debug = process.env.REACT_APP_DEBUG && false;
const sysMgmtApiRef = 'SystemManagementApi';
const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#_])[A-Za-z\d@$!%*?&#_]{8,}$/;
export const handleUserPasswordSaveClick = async ({ localObject, password, setPasswordError, setSnackbar, handleClose }) => {
    if (password && passwordPattern.test(password)) {
        debug && console.log('Password is valid and can be saved to system.', localObject, password);
        const response = await UserDAO.setUserPassword({ Username: localObject.username, Password: password, UserPoolId: undefined });
        if (response === undefined) {
            setSnackbar({
                children: `Error: You cannot change this user's password`,
                severity: 'error',
            });
        }
        if (response.err) {
            setSnackbar({
                children: `Error: ${response.err.message}`,
                severity: 'error',
            });
        }
        else {
            debug && console.log(`Set password success response`, response.data);
            setSnackbar({
                children: `Changed password for ${localObject?.name}`,
                severity: 'success',
            });
        }
        handleClose();
    }
    else {
        setPasswordError('Invalid password format');
    }
};
export const handleDeleteUser = async (user, userFunctions) => {
    console.log(`Detail Card handleDeleteLocalObject has localObjectType ${user.type}`);
    const res = await UserDAO.deleteUser(user);
    const { err, data } = res;
    if (err) {
        userFunctions.setUserMessage({
            id: v4(),
            content: `Failed to delete user ${user.name}${debug ? ` ${err.message}` : ''}`,
            label: 'System Management API',
            type: 'MessageBar',
            severity: Severity.error,
        });
    }
    else if (data) {
        userFunctions.removeObjectsFromState([user]);
        userFunctions.setUserMessage({
            id: v4(),
            content: `Deleted ${user.name}${debug ? ` (${data.sk})` : ''}`,
            label: 'System Management API',
            type: 'MessageBar',
            severity: Severity.success,
        });
    }
    else {
        userFunctions.setUserMessage({
            id: v4(),
            content: `Unexpexcted empty response when deleting ${user.name}${debug ? ` (SystemManagement API)` : ''}`,
            label: 'System Management API',
            type: 'MessageBar',
            severity: Severity.warning,
        });
    }
    return res;
};
export const saveAddUserRoles = async (rolesToAdd, userObj) => {
    // Add to groups
    const addPromises = rolesToAdd.map((r) => new Promise(async (res, rej) => {
        const addRoleRes = await UserDAO.addUserToGroup({ username: userObj.username, GroupName: r });
        if (addRoleRes.err) {
            rej({ ...addRoleRes, roleName: r });
            return;
        }
        else if (addRoleRes.data) {
            res({ ...addRoleRes, roleName: r });
            return;
        }
    }));
    const add_reses = await Promise.allSettled(addPromises);
    return {
        successes: add_reses.filter((r) => r.status === 'fulfilled'),
        fails: add_reses.filter((r) => r.status === 'rejected'),
    };
};
export const saveRemoveUserRoles = async (rolesToRemove, userObj) => {
    // Add to groups
    const removePromises = rolesToRemove.map((r) => new Promise(async (res, rej) => {
        const removeRoleRes = await UserDAO.removeUserFromGroup({ username: userObj.username, GroupName: r });
        if (removeRoleRes.err) {
            rej({ ...removeRoleRes, roleName: r });
            return;
        }
        else if (removeRoleRes.data) {
            res({ ...removeRoleRes, roleName: r });
            return;
        }
    }));
    const remove_reses = await Promise.allSettled(removePromises);
    return {
        successes: remove_reses.filter((r) => r.status === 'fulfilled'), // Why I have to cast this one and not the one below.. idk
        fails: remove_reses.filter((r) => r.status === 'rejected'),
    };
};
